import type { GridFieldType, TableDynamicColumn } from '@/features/Inventory/ObjectTypePassportGrid/model/types'
import {
  buildSegmentOrder,
  PB_TABLE_NAME_SEGMENT_ID,
  segmentSpans,
} from '@/features/Inventory/PassportBuilderV2/model/tableLayout'

export { PB_TABLE_NAME_SEGMENT_ID, buildSegmentOrder, segmentSpans }

export type ResolvedNameSegment = {
  kind: 'name'
  id: typeof PB_TABLE_NAME_SEGMENT_ID
  span: number
}

export type ResolvedColumnSegment = {
  kind: 'column'
  id: string
  span: number
  column: TableDynamicColumn
}

export type ResolvedTableSegment = ResolvedNameSegment | ResolvedColumnSegment

/**
 * Ordered header/body segments for a LIST table block inner 12-col grid, excluding the fixed
 * actions column (1). Spans sum to 11; actions consume the 12th unit — same invariant as builder.
 */
export function resolvedTableSegments(field: GridFieldType): ResolvedTableSegment[] {
  if (field.type !== 'table') return []
  const order = buildSegmentOrder(field)
  const spans = segmentSpans(field)
  const cols = field.table_columns ?? []
  const colById = new Map(cols.map((c) => [String(c.id), c]))
  const out: ResolvedTableSegment[] = []
  for (let i = 0; i < order.length; i++) {
    const id = order[i]
    const span = spans[i] ?? 1
    if (id === PB_TABLE_NAME_SEGMENT_ID) {
      out.push({ kind: 'name', id: PB_TABLE_NAME_SEGMENT_ID, span })
      continue
    }
    const col = colById.get(String(id))
    if (!col) continue
    out.push({ kind: 'column', id: String(id), span, column: col })
  }
  return out
}
